module.exports = __webpack_public_path__ + "img/sixIm.3d2015da.png";